import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
    getEditDomainPageData,
    getUserSingleDomains,
    editDomainRegisterInfo,
} from "../../../api/user/active-services/domain";
import Loading from "../../../components/loading";
import "./style.css";
import PhoneInput from "react-phone-input-2";
import Select from "react-select";
import countryList from "country-list";
import "react-phone-input-2/lib/style.css";

export default function EditDomainContactInfo() {
    const [formData, setFormData] = useState({
        contactid: "",
        company: "",
        zip: "",
        full_name: "",
        organization: "",
        phone: "",
        phone_cc: "",
        country: "",
        post_code: "",
        email: "",
        city: "",
        location: "",
    });
    const [loading, setLoading] = useState(true);
    const [pageData, setPageData] = useState(null);
    const { id } = useParams();

    useEffect(() => {
        const loadingData = async () => {
            const resFormData = (await getUserSingleDomains(id)).fullData;
            const data = resFormData.registrantcontact;

            const contactFormData = {
                contactid: data.contactid,
                company: data.company,
                zip: data.zip,
                full_name: data.name,
                organization: data.company,
                phone: data.telno,
                phone_cc: data.telnocc,
                country: data.country,
                post_code: data.zip,
                email: data.emailaddr,
                city: data.city,
                location: data.address1,
            };

            setFormData(contactFormData);

            const resPageData = await getEditDomainPageData();
            setPageData(resPageData);

            setLoading(false);
        };

        loadingData();
        window.scrollTo(0, 0);
    }, [id]);

    const countryOptions = countryList.getData().map((c) => ({
        value: c.code,
        label: c.name,
        flagUrl: `https://flagcdn.com/24x18/${c.code.toLowerCase()}.png`,
    }));

    const onChangeInput = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };

    if (loading) {
        return <Loading />;
    }

    const onSubmit = async (event) => {
        event.preventDefault();

        const body = {
            "contact-id": formData.contactid,
            name: formData.full_name,
            company: formData.company,
            email: formData.email,
            "address-line-1": formData.location,
            city: formData.city,
            zipcode: formData.zip,
            "phone-cc": formData.phone_cc,
            phone: formData.phone,
            country: formData.country,
        }

        console.log(body);
    };

    return (
        <div className="EditDomainContactInfo wrapper">
            <h1 className="edit-domain-contact-info-heading">{pageData.title}</h1>

            <form className="edit-domain-contact-info-form" onSubmit={onSubmit}>
                <div className="form_inner">
                    <div className="inputBox">
                        <label htmlFor="full_name_label">
                            {pageData.full_name_label}
                            <span>*</span>
                        </label>
                        <input
                            type="text"
                            id="full_name_label"
                            name="full_name"
                            value={formData.full_name}
                            onChange={onChangeInput}
                            readOnly
                        />
                    </div>

                    <div className="inputBox">
                        <label htmlFor="organization_label">
                            {pageData.organization_label}
                        </label>
                        <input
                            type="text"
                            id="organization_label"
                            value={formData.organization}
                            name="organization"
                            onChange={onChangeInput}
                            readOnly
                        />
                    </div>

                    <div className="inputBox">
                        <label htmlFor="company_label">
                            {pageData.company_label}
                        </label>
                        <input
                            type="text"
                            id="company_label"
                            value={formData.company}
                            name="company"
                            onChange={onChangeInput}
                            readOnly
                        />
                    </div>

                    <div className="inputBox">
                        <label htmlFor="phone_label">
                            {pageData.phone_label}
                            <span>*</span>
                        </label>

                        <PhoneInput
                            preferredCountries={["am", "ru", "ge", "us", "fr"]}
                            value={formData.phone_cc + formData.phone}
                            id="phone_label"
                            onChange={(value, data) => {
                                const localNumber = value.replace(data.dialCode, "");
                                setFormData({
                                    ...formData,
                                    phone: localNumber,
                                    phone_cc: data.dialCode,
                                });
                            }}
                            disableDropdown
                            inputStyle={{
                                width: "100%",
                                fontSize: "14px",
                                padding: "10px 50px",
                            }}
                            buttonStyle={{ borderRadius: "6px 0 0 6px" }}
                            inputProps={{ name: "phone", type: "text", readOnly: true, }}
                        />
                    </div>

                    <div className="inputBox">
                        <label htmlFor="country_label">
                            {pageData.country_label}
                            <span>*</span>
                        </label>

                        <Select
                            name="country"
                            id="country_label"
                            style={{ height: "0px" }}
                            // options={countryOptions}
                            menuIsOpen={false}
                            isSearchable={false}
                            components={{
                                DropdownIndicator: () => null,
                                IndicatorSeparator: () => null,
                            }}
                            value={
                                formData.country
                                    ? countryOptions.find((c) => c.value === formData.country)
                                    : null
                            }
                            onChange={(selectedOption) => {
                                setFormData({
                                    ...formData,
                                    country: selectedOption.value,
                                });
                            }}
                            placeholder={pageData.select_country}
                            formatOptionLabel={(option) => (
                                <div>
                                    <img
                                        src={option.flagUrl}
                                        alt={option.label}
                                        style={{
                                            width: "20px",
                                            height: "14px",
                                            marginRight: "10px",
                                        }}
                                    />
                                    <span>{option.label}</span>
                                </div>
                            )}
                            styles={{
                                control: (provided) => ({
                                    ...provided,
                                    borderRadius: "8px",
                                    padding: "5px 12px",
                                    border: "1px solid rgba(0,0,0,0.3)",
                                    boxShadow: "none",
                                    outline: "none",
                                    height: '50px',
                                    lineHeight: '50px',
                                }),
                                singleValue: (provided) => ({
                                    ...provided,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "30px",
                                    fontSize: "16px",
                                    fontFamily: "Inter, sans-serif",
                                    fontWeight: "600",
                                    letterSpacing: " 0.01em",
                                    color: "#00000082",
                                }),
                                placeholder: (provided) => ({
                                    ...provided,
                                    fontFamily: "Inter, sans-serif",
                                    fontWeight: "600",
                                    letterSpacing: " 0.01em",
                                    color: " #00000082",
                                }),
                                indicatorSeparator: () => ({
                                    display: "none",
                                }),
                                menu: (provided) => ({ ...provided, overflowX: "hidden" }),
                                option: (provided, state) => ({
                                    ...provided,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    padding: "5px 24px",
                                    fontFamily: "Inter, sans-serif",
                                    fontWeight: "600",
                                    letterSpacing: " 0.01em",
                                    fontWeight: "500",
                                    color: "#000",
                                    backgroundColor: state.isFocused ? "#f0f0f0" : "#fff",
                                }),
                            }}
                        />
                    </div>

                    <div className="inputBox">
                        <label htmlFor="post_code_label">
                            {pageData.post_code_label}
                            <span>*</span>
                        </label>
                        <input
                            type="text"
                            id="post_code_label"
                            value={formData.post_code}
                            name="post_code"
                            onChange={onChangeInput}
                            readOnly
                        />
                    </div>

                    <div className="inputBox">
                        <label htmlFor="email_label">
                            {pageData.email_label}
                            <span>*</span>
                        </label>
                        <input
                            type="text"
                            id="email_label"
                            value={formData.email}
                            name="email"
                            onChange={onChangeInput}
                            readOnly
                        />
                    </div>

                    <div className="inputBox">
                        <label htmlFor="city_label">
                            {pageData.city_label}
                            <span>*</span>
                        </label>
                        <input
                            type="text"
                            id="city_label"
                            value={formData.city}
                            name="city"
                            onChange={onChangeInput}
                            readOnly
                        />
                    </div>

                    <div className="inputBox">
                        <label htmlFor="location_label">
                            {pageData.location_label}
                            <span>*</span>
                        </label>
                        <input
                            type="text"
                            id="location_label"
                            value={formData.location}
                            name="location"
                            onChange={onChangeInput}
                            readOnly
                        />
                    </div>
                </div>

                {/* <button className="btn" type="submit">
                    {pageData.btn_text}
                </button> */}
            </form>
        </div>
    );
}